


/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import {Embedding} from '../../core/_models'
import { stat } from 'fs'

type Props = {
  embedding: Embedding
}
const status ={
   'Activated' :  'badge badge-light-success fs-8 fw-bold',
   'Not Active' : 'badge badge-light-danger fs-8 fw-bold',
   'Processing' : 'badge badge-light-warning fs-8 fw-bold' 
}
const UserStatuCell: FC<Props> = ({embedding}) => {
 
 return (
 <>
 
 <span className={`${status[embedding?.isActive as keyof typeof status || '']}`}>{embedding.isActive}</span>
 </>
 );

}


const EmbeddingStatusCell: FC<Props> = ({embedding}) => {
 
   return (
   <>
    {embedding.embeddingGenerated &&
       <span className='badge badge-light-success fs-8 fw-bold'>Available</span>
    }
    {!embedding.embeddingGenerated &&
       <span className='badge badge-light-danger fs-8 fw-bold'>Not Available</span>
    }
   </>
   );
  
  }

export {UserStatuCell,EmbeddingStatusCell}

